module.exports = __webpack_public_path__ + "img/logo-wordmark-white.ad3593b.svg";